import { render, staticRenderFns } from "./ContractViewsOverlappingRevisions.yaml?vue&type=template&id=72b7a5a5&component"
import script from "./ContractViewsOverlappingRevisions.yaml?vue&type=script&lang=ts&component"
export * from "./ContractViewsOverlappingRevisions.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports